<template>
    <div class="addGoods spackage padding-20 bgc box-shadow">
        <div class="edit_content_warp form">
            <div class="title_box">基本信息</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="商品名称" prop="goodsName">
                    <el-input :disabled="this.$route.query.edit !== undefined" v-model="ruleForm.goodsName" placeholder="输入商品名称，不超过40个字" style="width: 400px; margin-right: 10px;"></el-input>
                    <el-button v-if="!(this.$route.query.edit !== undefined) && this.$route.query.status !== '10'" :disabled="this.$route.query.edit !== undefined" @click="importBtn" style="width: 140px;" plain>导入素材库商品</el-button>
                    <el-button v-if="!(this.$route.query.edit !== undefined) && this.$route.query.status !== '10'" :disabled="this.$route.query.edit !== undefined" @click="addNewGoodsBtn" style="width: 140px;" type="primary">添加素材库商品</el-button>
                </el-form-item>
                <el-form-item label="商品分类" prop="goodsClass">
                    <p v-if="this.$route.query.edit !== undefined">{{goodsClassName}}</p>
                    <el-select v-if="!(this.$route.query.edit !== undefined)" v-model="ruleForm.goodsClass" style="width: 316px;" placeholder="请选择商品分类">
                        <el-option v-for="(item, index) in goodsClassList" :key="index" :label="item.name" :value="item.innerid"></el-option>
                    </el-select>
                    <el-button v-if="!(this.$route.query.edit !== undefined)" :disabled="this.$route.query.edit !== undefined" @click="addClass" type="text">添加分类</el-button>
                </el-form-item>
                <el-form-item label="商品图片" prop="goodsImg">
                    <div class="goods_img_set_box">
                        <img :src="ruleForm.goodsImg.furl === '' ? require('@/common/images/communityPurchases/default.png') : ruleForm.goodsImg.furl" alt="">
                        <div v-if="!(this.$route.query.edit !== undefined)">
                            <uploadFile :uploadType="uploadType" @setFile="setFile" :fileRule="fileRule" ref="uploadFile"></uploadFile>
                            <p>建议尺寸350*350px的JPG、PNG格式， 图片小于2M。</p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="商品价格" prop="goodsPrice">
                    <el-input :disabled="this.$route.query.edit !== undefined || this.$route.query.status === '10'" v-model="ruleForm.goodsPrice" placeholder="输入商品的价格" style="width: 400px; margin-right: 10px;"></el-input>
                    <span v-if="!(this.$route.query.edit !== undefined)" style="color: #F56C6C; font-size: 12px;">进行中的活动商品将不能更改商品售价，请注意填写！</span>
                </el-form-item>
                <el-form-item label="划线价格" prop="markPrice">
                    <el-input :disabled="this.$route.query.edit !== undefined" v-model="ruleForm.markPrice" placeholder="输入商品的划线价格" style="width: 400px;"></el-input>
                </el-form-item>
                <el-form-item label="总库存数" prop="goodsTotal">
                    <el-input :disabled="this.$route.query.edit !== undefined" v-model="ruleForm.goodsTotal" placeholder="输入商品总库存" style="width: 400px; margin-right: 10px;"></el-input>
                    <span v-if="!(this.$route.query.edit !== undefined)" style="color: #F56C6C; font-size: 12px;">限制库存情况下，只能增加不能减少。</span>
                </el-form-item>
                <el-form-item label="每单限购量" prop="purchasing">
                    <el-input :disabled="this.$route.query.edit !== undefined" v-model="ruleForm.purchasing" placeholder="输入每单限购量" style="width: 400px; margin-right: 10px;"></el-input>
                    <span v-if="!(this.$route.query.edit !== undefined)" style="color: #C0C4CC; font-size: 12px;">0为不限制购买量</span>
                </el-form-item>
                <el-form-item label="商品详情">
                    <div class="ueditorBox">
                        <uEditor3 :content="ruleForm.goodsdetails" ref="uEditor" @getUEditorContent="getMsgContent"></uEditor3>
                    </div>
                </el-form-item>
                <el-form-item>
                    <!-- <el-button plain @click="resetForm('ruleForm')">取消</el-button> -->
                    <el-button plain @click="cancel">取消</el-button>
                    <el-button :disabled="this.$route.query.edit !== undefined" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="add_goods_pop">
            <AddGoodsPop @sureAddGoods="sureAddGoods" :goodsClassData="goodsClassList" ref="addGoodsPop"></AddGoodsPop>
        </div>
        <div class="add_classify_pop">
            <el-dialog title="添加分类" :visible.sync="addClassifyPop" @close='closeDialog'>
                <el-form :model="gcFormData" :rules="rules" ref="gcFormData">
                    <el-form-item label="分类名称" label-width="80px" prop="classifyName">
                        <el-input type="text" v-model="gcFormData.name" minLength="1" maxLength="8" autocomplete="off" placeholder="输入分类名称，不超过8个字" class="textStyle"></el-input>
                    </el-form-item>
                    <el-form-item label="分类说明" label-width="80px" prop="memo">
                        <el-input type="textarea" :rows="4" v-model="gcFormData.memo" maxLength="80" autocomplete="off" placeholder="输入分类说明，不超过80个字" class="textStyle"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addClassifyPop = false">取 消</el-button>
                    <el-button type="primary" @click="sureAddClassify('gcFormData')">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import AddGoodsPop from 'views/communityPurchase/managementOfPurchaseAndPurchase/components/AddGoodsPop'
import UploadFile from 'base/upload/uploadFile'
import UEditor3 from 'base/uEditor/uEditor3'
// import {formatFileInfo} from 'common/js/tools'
import {getMaterialCategory, saveOrUpdateProductInfo, getProductInfo, saveOrUpdateMaterialCategory} from 'api/cPurchaseApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'AddGoods',
    data() {
        // 检查商品图片
        let validateGoodsImg = (rule, value, callback) => {
            // if (!value.furl) {
            if (this.ruleForm.goodsImg.furl === '') {
                callback(new Error('请选择商品图片'))
            } else {
                callback()
            }
        }
        // 检查商品价格
        let validateGoodsPrice = (rule, value, callback) => {
            if (parseInt(value) < 0) {
                callback(new Error('商品价格不能为负数'))
            } else if (isNaN(parseInt(value))) {
                // console.log(parseInt(value))
                callback(new Error('请输入数字'))
            } else {
                // console.log(isNaN(parseInt(value)))
                callback()
            }
        }
        // 检查商品划线价格
        let validateGoodsMarkPrice = (rule, value, callback) => {
            if (parseInt(value) < parseInt(this.ruleForm.goodsPrice) && parseInt(value) !== 0 && parseInt(value) !== '') {
                callback(new Error('划线价格不能小于商品价格'))
            } else if (isNaN(parseInt(value)) && value !== '') {
                // console.log(value)
                // console.log(parseInt(value))
                callback(new Error('请输入数字'))
            } else {
                callback()
            }
        }
        // 检查商品库存
        let goodsInventory = (rule, value, callback) => {
            // console.log(this.goodsStock)
            if (parseInt(this.ruleForm.goodsTotal) < 0) {
                callback(new Error('商品库存数不能小于0'))
            } else if (parseInt(this.ruleForm.goodsTotal) < this.goodsStock) {
                callback(new Error('商品库存数只能增加不能减少'))
            } else {
                callback()
            }
        }
        return {
            addClassifyPop: false,
            gcFormData: {
                name: '',
                memo: ''
            },
            fileRule: {
                btnName: '选择文件',
                cls: '',
                accept: 'image/png,image/jpeg,image/gif',
                size: 2,
                width: 350,
                height: 350
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            materialId: '',
            addGoodsType: '',
            goodsClassName: '',
            goodsClassList: [],
            goodsStock: 0,
            ruleForm: {
                goodsName: '', // 商品名称
                goodsClass: '', // 商品分类
                goodsImg: {
                    furl: ''
                }, // 商品图片
                goodsPrice: '', // 商品价格
                markPrice: '', // 划线价格
                goodsTotal: '', // 总库存数
                purchasing: 0, // 每单限购量
                goodsdetails: '' // 商品详情
            },
            rules: {
                goodsName: [
                    {required: true, message: '请输入商品名称', trigger: 'blur'}
                ],
                goodsClass: [
                    {required: true, message: '请选择商品分类', trigger: 'change'}
                ],
                goodsImg: [
                    {required: true, validator: validateGoodsImg, trigger: 'blur'}
                ],
                goodsPrice: [
                    {required: true, message: '请输入商品价格', trigger: 'blur'},
                    {required: true, validator: validateGoodsPrice, trigger: 'blur'}
                ],
                markPrice: [
                    {validator: validateGoodsMarkPrice, trigger: 'blur'}
                ],
                goodsTotal: [
                    {required: true, message: '请输入商品总库存量', trigger: 'blur'},
                    {required: true, validator: goodsInventory, trigger: 'blur'}
                ],
                purchasing: [
                    {required: true, message: '请输入每单限购量', trigger: 'blur'}
                ],
                classifyName: [
                    // {required: true, message: '请输入分类名称', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        this.getGoodsClass()
        if (this.$route.query.innerid) {
            this.editGoodsinfo()
        }
    },
    methods: {
        // 关闭添加分类弹框
        closeDialog() {
            this.addClassifyPop = false
            this.gcFormData.name = ''
            this.gcFormData.memo = ''
        },
        // 确定添加分类
        sureAddClassify(formName) {
            // console.log(this.gcFormData)
            if (this.gcFormData.name === '') {
                this.$message.error('请输入分类名称！')
                return
            }
            this.setLoading(true)
            let data = {
                innerid: '',
                name: this.gcFormData.name,
                memo: this.gcFormData.memo
            }
            saveOrUpdateMaterialCategory({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.$message.success('添加分类成功')
                    this.addClassifyPop = false
                    this.gcFormData.name = ''
                    this.gcFormData.memo = ''
                    this.getGoodsClass()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 素材库弹窗添加商品
        sureAddGoods(value) {
            // console.log(value)
            this.addGoodsType = 2
            this.materialId = value.innerid
            this.ruleForm.goodsName = value.name
            this.ruleForm.goodsClass = value.catecode
            this.ruleForm.goodsImg.furl = value.logoatturlid
            this.ruleForm.goodsImg.key = value.logoatturlid
            this.ruleForm.goodsImg.fname = value.name
            this.ruleForm.goodsPrice = value.saleprice
            this.ruleForm.markPrice = value.uprice
            this.ruleForm.goodsTotal = value.stockcount
            this.ruleForm.purchasing = value.limitcountbyorder
            this.ruleForm.goodsdetails = value.materialdesp
            this.$refs.uEditor.init(this.ruleForm.goodsdetails)
            this.$refs['ruleForm'].validate((valid) => {
                // if (valid) {
                // } else {
                // }
            })
        },
        // 编辑商品详情
        editGoodsinfo() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                innerid: this.$route.query.innerid
            }
            getProductInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.ruleForm.goodsName = data.data.productname
                    this.ruleForm.goodsClass = data.data.catecode
                    this.goodsClassName = data.data.catename
                    this.ruleForm.goodsImg.furl = data.data.coveratturlid
                    this.ruleForm.goodsImg.key = data.data.coverattid
                    this.ruleForm.goodsPrice = data.data.saleprice
                    this.ruleForm.markPrice = data.data.uprice
                    this.ruleForm.goodsTotal = data.data.stockcount
                    this.goodsStock = parseInt(data.data.stockcount)
                    this.ruleForm.purchasing = data.data.limitcountbyorder
                    this.ruleForm.goodsdetails = data.data.desp
                    this.$refs.uEditor.init(this.ruleForm.goodsdetails)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 导入素材库商品
        importBtn() {
            this.$refs.addGoodsPop.openDialog()
        },
        // 添加素材库商品
        addNewGoodsBtn() {
            let newurl = this.$router.resolve({
                name: 'goodsMaterial'
            })
            window.open(newurl.href, '_blank')
        },
        // 获取分类列表
        getGoodsClass() {
            this.setLoading(true)
            getMaterialCategory({
                // data: Object.assign({}),
                success: data => {
                    this.setLoading(false)
                    this.goodsClassList = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 添加分类按钮
        addClass() {
            // this.$router.push({name: 'goodsCategory'})
            this.addClassifyPop = true
        },
        // 提交表单并验证
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!')
                    // console.log(this.ruleForm)
                    this.sureSubmit(this.ruleForm)
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        // 新增、编辑商品保存
        sureSubmit(value) {
            // console.log(value)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                productname: value.goodsName,
                catecode: value.goodsClass,
                coverattid: value.goodsImg.key,
                coveratturlid: value.goodsImg.furl,
                saleprice: value.goodsPrice,
                uprice: value.markPrice,
                stockcount: value.goodsTotal,
                limitcountbyorder: value.purchasing,
                desp: value.goodsdetails,
                productsource: '1',
                kmctype: '',
                kmckeyid: ''
            }
            if (this.addGoodsType === 2) {
                params.productsource = '2'
                params.kmckeyid = this.materialId
            }
            if (this.$route.query.innerid) {
                params.innerid = this.$route.query.innerid
                if (!value.goodsImg.fname) {
                    params.coverattid = ''
                    params.coveratturlid = ''
                }
            }
            // console.log(params)
            this.setLoading(true)
            saveOrUpdateProductInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    window.history.back()
                    // this.$message.success(`新增成功`)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 取消按钮
        cancel() {
            // this.$message.error(`取消`)
            window.history.back()
        },
        // resetForm(formName) {
        //     this.$refs[formName].resetFields()
        // },
        // 商品详情
        getMsgContent(content) {
            this.ruleForm.goodsdetails = content
        },
        // 上传图片
        setFile(file) {
            // console.log(file)
            this.ruleForm.goodsImg = file
            this.$refs.uploadFile.initUploadParam()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        UploadFile,
        UEditor3,
        AddGoodsPop
    }
}
</script>

<style lang="scss" type="text/scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
    .addGoods{
        .form{
            margin-top: 0;
        }
        .edit_content_warp{
            .title_box{
                border-left: 2px solid #409EFF;
                padding-left: 10px;
                font-size: 16px;
                margin-top: 10px;
                margin-bottom: 20px;
            }
            .el-form-item__label {
                text-align: left;
            }
            .goods_img_set_box{
                display: flex;
                &>img{
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                    margin-right: 24px;
                }
                &>div{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    .el-button{
                        min-width: 96px;
                        height: 32px;
                        padding: 0;
                        background: #fff;
                        border: 1px solid #C0C4CC;
                        color: #606266;
                    }
                    .el-button:hover{
                        border: 1px solid #409EFF;
                        color: #409EFF;
                    }
                    &>p{
                        color: #909399;
                    }
                }
            }
        }
        .add_goods_pop{
            .el-dialog__wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: left;
            }
            .el-dialog {
                width: 800px;
                // height: 600px;
                margin: 0!important;
            }
            .el-dialog .el-dialog__body {
                padding: 0px!important;
                height: 100%;
            }
        }
    }
</style>
